(function () {
	/**
	 * Returns value of a given cookie
	 *
	 * @param {string} name
	 * @return {string|null}
	 */
	function getCookie(name) {
		function escape(s) {
			return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1');
		}
		const match = document.cookie.match(new RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
		return match ? match[1] : null;
	}

	document.addEventListener('DOMContentLoaded', function () {
		const cookie = getCookie('tec_items_in_cart');
		const cartItems = document.querySelectorAll('.tec-cart-link');

		if (cookie && cookie >= 1 && cartItems.length) {
			cartItems.forEach(function (cartItem) {
				cartItem.classList.remove('tec-cart-link--hidden');

				const linkContent = cartItem.querySelector('.kb-nav-link-content');
				if (linkContent) {
					let quantitySpan = linkContent.querySelector('.tec-cart-quantity');
					if (!quantitySpan) {
						quantitySpan = document.createElement('span');
						quantitySpan.className = 'tec-cart-quantity';
						linkContent.appendChild(quantitySpan);
					}
					quantitySpan.innerHTML = cookie;
				}
			});
		}
	});
})();
